'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyGdprConsent = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _gdprConsentToProcessEnabled = require('conversations-schema/operators/widget-data/gdprConsentToProcessEnabled');

var _gdprExplicitConsentRequired = require('conversations-schema/operators/widget-data/gdprExplicitConsentRequired');

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var _visitorConsentsToProcess = require('../../gdpr/actions/visitorConsentsToProcess');

var _getHasGivenConsentToProcess = require('../../gdpr/selectors/getHasGivenConsentToProcess');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var applyGdprConsent = exports.applyGdprConsent = function applyGdprConsent(_ref) {
  var widgetData = _ref.widgetData;
  return function (dispatch, getState) {
    if ((0, _gdprConsentToProcessEnabled.gdprConsentToProcessEnabled)(widgetData) && !(0, _getHasGivenConsentToProcess.getHasGivenConsentToProcess)(getState()) && !(0, _gdprExplicitConsentRequired.gdprExplicitConsentRequired)(widgetData)) {
      dispatch((0, _visitorConsentsToProcess.consentToProcess)({
        sessionId: (0, _WidgetDataModel.getSessionId)(widgetData)
      }));
    }
    return _q2.default.Promise.resolve();
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/applyGdprConsent.js
// module id = 647
// module chunks = 2 3